import { getKitList } from "@src/redux/index";
import { Form, Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const { Option } = Select;

const Kit: React.FC = () => {
  const { result: kitList } = useSelector(getKitList);

  return (
    <Form.Item
      name="kit"
      label="Kit"
      rules={[{ required: true, message: "Kit is required." }]}
    >
      <Select
        placeholder=""
        options={kitList?.items || []}
        fieldNames={{ value: "id", label: "referenceId" }}
        filterOption={(input, option) =>
          (option?.referenceId ?? "")
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        showSearch
      />
    </Form.Item>
  );
};

export default Kit;
